import { ThreeItemKeys, ThreeItemTypes } from '../../../constants/three'
import { getObjectsByUserData } from '../../../helpers/scene-json'
import { createQuery } from '@tanstack/svelte-query'
import { get } from 'svelte/store'
import { storeScene } from '../../../stores/scene'
import queryClient from '../../../constants/query-client'

const useGroupsQueries = () => {
  const getGroups = () => {
    const scene = get(storeScene)
    return getObjectsByUserData(scene, ThreeItemKeys.ITEM_TYPE, ThreeItemTypes.GROUP)
  }

  const useGroups = () => createQuery(() => ({
    queryKey: ['canvas', 'groups'],
    queryFn: getGroups,
  }), () => queryClient)

  return {
    useGroups,
  }
}

export default useGroupsQueries
